import { useEffect, useState } from "react";
import {
  Autocomplete,
  Box,
  Button,
  Checkbox,
  Chip,
  FormControlLabel,
  IconButton,
  Tab,
  Tabs,
  TextField,
  Typography,
} from "@mui/material";
import AddIcon from "@mui/icons-material/Add";
import Grid from "@mui/material/Grid2";
import { ReactComponent as CrossIcon } from "../../Assets/cross.svg";
import { ToastContainer } from "react-toastify";

import {
  CreateUserSegement,
  EditUserSegement,
  getCountryList,
  getUserSegmentDetails,
} from "../../Services/ExperienceApi";
import Accordion from "@mui/material/Accordion";
import AccordionSummary from "@mui/material/AccordionSummary";
import AccordionDetails from "@mui/material/AccordionDetails";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import { useLocation, useNavigate } from "react-router-dom";
import { toast } from "react-toastify";
import { ReactComponent as ArrowbackIcon } from "../../Assets/arrowback.svg";
import React from "react";

const EditUserSegment = () => {
  const [tabValue, setTabValue] = useState("all_users");
  const navigate = useNavigate();
  const [loading, setIsLoading] = useState(false);
  const [newLocation, setNewLocation] = useState<
    { name: string; code: string; region: string }[]
  >([]);
  const [selectedLocation, setSelectedLocation] = useState<{
    name: string;
    code: string;
    region: string;
  } | null>(null);
  const [title, setTitle] = useState("User Segment");
  const [deviceChecked, setDeviceChecked] = useState(false);
  const osToDeviceMap: Record<string, string> = {
    windows: "Windows",
    mac: "Mac",
    linux: "Linux",
    "other desktop systems": "Other desktop systems",
    android: "Android",
    ios: "Ios",
    "other mobile/tablet systems": "Other mobile/tablet systems",
  };

  const UTMOptions = ["Source", "Medium", "Campaign", "Term", "Content"];
  const browserDisplayLabels: Record<string, string> = {
    chrome: "Chrome",
    safari: "Safari",
    edge: "Edge",
    other_browser: "Other browser",
    firefox: "Firefox",
    ie: "IE",
    opera: "Opera",
  };
  const AdblockersList = [
    { label: "No adblockers", value: "no_adblockers" },
    { label: "Adblockers enabled", value: "adblockers_enabled" },
  ];
  const DeviceList = ["mobile", "tablet", "desktop"];
  const [osChecked, setOsChecked] = useState(false);
  const [browserChecked, setBrowserChecked] = useState(false);
  const [addBlockerChecked, setaddBlockerChecked] = useState(false);
  const [onFirstVisit, setOnFirstVisit] = useState(false);
  const [geoChecked, setGeoChecked] = useState(false);
  const [postalChecked, setpostalChecked] = useState(false);
  const [referredChecked, setReferredChecked] = useState(false);
  const [utmChecked, setUtmChecked] = useState(false);
  const [hostChecked, setHostChecked] = useState(false);
  const [selectedLocationsList, setSelectedLocationsList] = useState<
    { name: string; code: string; region: string }[]
  >([]);
  const [selectedAdblocker, setSelectedAdblocker] = useState("");
  const [variables, setVariables] = useState([
    { id: 1, name: '', equals: true, value: [] },
  ]);
  
  const [postalCode, setPostalCode] = useState("");
  const [cookies, setCookies] = useState<any[]>([
    { id: 1, name: '', equals: true, value: [] },
  ]);
  const [postalCodesList, setPostalCodesList] = useState<string[]>([]);
  const [linkAddress, setLinkAddress] = useState("");
  const [referredSources, setReferredSources] = useState<string[]>([]);
  const [utmValue, setUtmValue] = useState("");
  const [utmList, setUtmList] = useState<string[]>([]);
  const [hostValue, setHostValue] = useState("");
  const [hostList, setHostList] = useState<string[]>([]);
  const [utmCategories, setUtmCategories] = useState<any>({});
  const [geoToggle, setGeoToggle] = useState("IGNORE");
  const [postalToggle, setPostalToggle] = useState("IGNORE");
  const [refferedToggle, setRefferedToggle] = useState("IGNORE");
  const [utmToggle, setUtmToggle] = useState("IGNORE");
  const [hostToggle, setHostToggle] = useState("IGNORE");
  const [selectedDevices, setSelectedDevices] = useState<
    Record<string, boolean>
  >({
    mobile: false,
    tablet: false,
    desktop: false,
  });
  const location = useLocation();
  const sessionData = sessionStorage.getItem("pendingNodeAddition");
  const sessionObj = sessionData ? JSON.parse(sessionData) : {};
  const segment = location.state?.data.id || "";
  const experienceId =
    location.state?.data.experinceId || sessionObj.experinceId;
  let segmentId: string | null = null;
  if (segment) {
    const parts = segment.split("_");
    segmentId = parts.length > 1 ? parts[1] : segment;
  }
  const [selectedOS, setSelectedOS] = useState<Record<string, boolean>>({
    Windows: false,
    Mac: false,
    Linux: false,
    Android: false,
    iOS: false,
  });
  const userTypeList = [
    { key: "anonymous", label: "Anonymous" },
    { key: "subscriber", label: "Subscriber" },
    { key: "expired_user", label: "Expired User" },
    { key: "suspended_user", label: "Suspended User" },
    { key: "nation_user", label: "Nation User" },
    { key: "free_user", label: "Free User" },
    { key: "staff_subscriber", label: "Staff Subscriber" },
    { key: "premium_subscriber", label: "Premium Subscriber" },
    { key: "cms_user", label: "CMS User" },
  ];

  const [userTypes, setUserTypes] = useState(
    Object.fromEntries(userTypeList.map(({ key }) => [key, false]))
  );
  const [titleError, setTitleError] = useState(false);
  // Replace your current browserChecked state with:
  const [selectedBrowsers, setSelectedBrowsers] = useState<
    Record<string, boolean>
  >(
    Object.keys(browserDisplayLabels).reduce(
      (acc, browser) => ({ ...acc, [browser]: false }),
      {}
    )
  );

  const fetchExperience = async () => {
    if ((!segmentId || segmentId !== "default") && experienceId) {
      const response = await getUserSegmentDetails(experienceId, segmentId);
      if (response.success === true && response?.userSegments) {
        const segmentData = response.userSegments[0];
        setTitle(segmentData.segment_name);
        setTabValue(segmentData.audience_type);
        if (segmentData.user_type && Array.isArray(segmentData.user_type)) {
          const updatedTypes: Record<string, boolean> = userTypeList.reduce(
            (acc, curr) => {
              acc[curr.key] = segmentData.user_type.includes(curr.key);
              return acc;
            },
            {} as Record<string, boolean>
          );

          setUserTypes(updatedTypes);
        }

        setOnFirstVisit(segmentData.on_first_visit);
        const targetDevices = Array.isArray(segmentData.target_devices)
          ? segmentData.target_devices
          : [];
        const targetOS = Array.isArray(segmentData.target_os)
          ? segmentData.target_os
          : [];
        const targetBrowsers = Array.isArray(segmentData.target_browsers)
          ? segmentData.target_browsers
          : [];
        const adbBlockers = segmentData.adblockers;
        setaddBlockerChecked(adbBlockers?.length > 0);
        setSelectedAdblocker(adbBlockers);
        setDeviceChecked(targetDevices.length > 0);
        setOsChecked(targetOS.length > 0);
        setBrowserChecked(targetBrowsers.length > 0);
        const devicesObj: any = {};
        targetDevices.forEach((device: any) => {
          devicesObj[device] = true;
        });
        setSelectedDevices(devicesObj);

        const osObj: any = {};
        targetOS.forEach((os: any) => {
          osObj[os] = true;
        });
        setSelectedOS(osObj);

        const browsersObj: any = {};
        targetBrowsers.forEach((browser: any) => {
          browsersObj[browser] = true;
        });
        setSelectedBrowsers(browsersObj);
        // Safely parse geoLocations
        let geoLocations: any[] = [];

        if (typeof segmentData.geographic_locations === "string") {
          try {
            geoLocations = JSON.parse(segmentData.geographic_locations);
          } catch (err) {
            console.error("Error parsing geographic_locations:", err);
            geoLocations = [];
          }
        } else if (Array.isArray(segmentData.geographic_locations)) {
          geoLocations = segmentData.geographic_locations;
        } else {
          geoLocations = [];
        }

        if (typeof segmentData.geographic_locations === "string") {
          try {
            geoLocations = JSON.parse(segmentData.geographic_locations);
          } catch (err) {
            console.error("Error parsing geographic_locations:", err);
            geoLocations = [];
          }
        } else if (Array.isArray(segmentData.geographic_locations)) {
          geoLocations = segmentData.geographic_locations;
        } else {
          geoLocations = [];
        }

        setGeoChecked(geoLocations.length > 0);
        setSelectedLocationsList(geoLocations);
        const geoToggle = geoLocations
          .find((loc: any) => loc.toggle)
          ?.toggle?.toUpperCase();
        setGeoToggle(geoToggle);

        if ((geoLocations.length > 0 && geoChecked) || newLocation.length > 0) {
          const firstGeo = geoLocations[0];

          if (firstGeo) {
            const selected = {
              name: firstGeo.name || "",
              code: firstGeo.region || "",
              region: firstGeo.region || firstGeo.code || "",
            };
            setSelectedLocation(selected);
          }
        }

        let parsedPostalCodes: any[] = [];
        try {
          const rawPostalCodes = segmentData.postal_code_locations;
          const data =
            typeof rawPostalCodes === "string"
              ? JSON.parse(rawPostalCodes || "[]")
              : rawPostalCodes;

          parsedPostalCodes = Array.isArray(data) ? data : [];
        } catch (e) {
          parsedPostalCodes = [];
        }

        setPostalCodesList(parsedPostalCodes.map((pc: any) => pc.postal_code));
        setpostalChecked(parsedPostalCodes.length > 0);
        const toggleFromFirstItem = parsedPostalCodes
          .find((pc: any) => pc.toggle)
          ?.toggle?.toUpperCase();
        setPostalToggle(toggleFromFirstItem);

        let referredData: { urls: string[]; toggle: string } = {
          urls: [],
          toggle: "TARGET",
        };

        try {
          const rawReferred = segmentData.referred_from;
          referredData =
            typeof rawReferred === "string"
              ? JSON.parse(rawReferred || "{}")
              : rawReferred || { urls: [], toggle: "TARGET" };
        } catch (e) {
          referredData = { urls: [], toggle: "TARGET" };
        }

        setReferredChecked(referredData.urls?.length > 0);
        setRefferedToggle(referredData.toggle?.toUpperCase() || "TARGET");
        setReferredSources(referredData.urls || []);

        let utmData: { toggle: string; values: Record<string, string[]> } = {
          toggle: "TARGET",
          values: {},
        };

        try {
          const rawUtm = segmentData.utm;
          utmData =
            typeof rawUtm === "string"
              ? JSON.parse(rawUtm || "{}")
              : rawUtm || utmData;
        } catch {
          // fallback in case parsing fails
          utmData = { toggle: "TARGET", values: {} };
        }

        setUtmChecked(Object.keys(utmData.values || {}).length > 0);
        setUtmToggle(utmData.toggle?.toUpperCase());

        const values = utmData.values || {};
        const tempList: string[] = [];
        const tempCategories: { [key: string]: string } = {};

        Object.entries(values).forEach(([category, items]) => {
          (items as string[]).forEach((val) => {
            tempList.push(val);
            tempCategories[val] = category;
          });
        });

        setUtmList(tempList);
        setUtmCategories(tempCategories);
        let hostData: { toggle: string; values: string[] } = {
          toggle: "TARGET",
          values: [],
        };

        try {
          const rawHost = segmentData.host_ip_domains;
          hostData =
            typeof rawHost === "string"
              ? JSON.parse(rawHost || "{}")
              : rawHost || hostData;
        } catch {
          hostData = { toggle: "TARGET", values: [] };
        }

        setHostChecked(hostData.values?.length > 0);
        setHostToggle(hostData.toggle?.toUpperCase());
        setHostList(hostData.values || []);

        let customVars: any[] = [];
        let customCookies: any[] = [];

        try {
          const rawVars = segmentData.custom_variables;
          customVars =
            typeof rawVars === "string"
              ? JSON.parse(rawVars || "[]")
              : rawVars || [];
        } catch {
          customVars = [];
        }
        const mappedVariables: any = customVars.map(
          (varData: any, index: number) => {
            const processedValue = Array.isArray(varData.value)
              ? varData.value
              : typeof varData.value === "string"
              ? varData.value.split(",").map((v: any) => v.trim())
              : [];

            // if (index === 0) {
            //   setVariables(processedValue);
            // }

            return {
              id: index,
              name: varData.name,
              value: processedValue,
              equals: varData.condition === "equals_one_of",
            };
          }
        );

        setVariables(mappedVariables);
        try {
          const rawVars = segmentData.custom_cookies;
          customCookies =
            typeof rawVars === "string"
              ? JSON.parse(rawVars || "[]")
              : rawVars || [];
        } catch {
          customCookies = [];
        }
        const mappedCookies = customCookies.map(
          (varData: any, index: number) => {
            const processedValue = Array.isArray(varData.value)
              ? varData.value
              : typeof varData.value === "string"
              ? varData.value.split(",").map((v: any) => v.trim())
              : [];

            // if (index === 0) {
            //   setCookieValues(processedValue);
            // }

            return {
              id: index,
              name: varData.name,
              value: processedValue,
              equals: varData.condition === "equals_one_of",
            };
          }
        );

        setCookies(mappedCookies);
      } else {
        console.log("Error fetching segment data");
      }
    }
  };
  useEffect(() => {
    if (geoChecked) {
      fetchGeoLocations();
    }
  }, [geoChecked]);

  useEffect(() => {
    fetchExperience();
  }, [segmentId, experienceId]);

  const handleDeviceChange = (event: any) => {
    setDeviceChecked(event.target.checked);
  };
  const handleOsChange = (event: any) => {
    setOsChecked(event.target.checked);
  };
  const handleBrowserChange = (event: any) => {
    setBrowserChecked(event.target.checked);
  };
  const handleAddBlockerChange = (event: any) => {
    setaddBlockerChecked(event.target.checked);
  };
  const fetchGeoLocations = async () => {
    try {
      const response = await getCountryList();
      if (response.success === true) {
        setNewLocation(response.data);
      }
    } catch (error) {
      console.error("Error adding location:", error);
    }
  };

  const handleChange = (event: any, newValue: any) => {
    setTabValue(newValue);
  };
  const handleAddLocation = () => {
    const currentList = Array.isArray(selectedLocationsList)
      ? selectedLocationsList
      : [];

    if (
      selectedLocation &&
      !currentList.some((loc) => loc.code === selectedLocation.code)
    ) {
      setSelectedLocationsList([...currentList, selectedLocation]);
    }

    setSelectedLocation(null);
  };

  const handleRemoveLocation = (code: string) => {
    setSelectedLocationsList(
      selectedLocationsList.filter((loc) => loc.code !== code)
    );
  };
  const handleRemovePostal = (index: number) => {
    setPostalCodesList(postalCodesList.filter((_, i) => i !== index));
  };

  const handleAddPostalCode = () => {
    const trimmedCode = postalCode.trim();
    if (trimmedCode !== "" && !postalCodesList.includes(trimmedCode)) {
      setPostalCodesList([...postalCodesList, trimmedCode]);
    }
    setPostalCode(""); // Clear input after adding
  };

  const handleAddLink = () => {
    const trimmedLink = linkAddress.trim();
    if (trimmedLink !== "" && !referredSources.includes(trimmedLink)) {
      setReferredSources([...referredSources, trimmedLink]);
    }
    setLinkAddress(""); // Clear input after adding
  };

  const handleRemoveLink = (index: number) => {
    setReferredSources(referredSources.filter((_, i) => i !== index));
  };
  const handleAddUTM = () => {
    const trimmedUTM = utmValue.trim();
    if (trimmedUTM !== "" && !utmList.includes(trimmedUTM)) {
      setUtmList([...utmList, trimmedUTM]);
      setUtmCategories({ ...utmCategories, [utmValue.trim()]: "Source" }); // Default category: "Source"
    }
    setUtmValue(""); // Clear input after adding
  };
  const handleCategoryChange = (utm: any, newCategory: any) => {
    setUtmCategories({ ...utmCategories, [utm]: newCategory });
  };

  // Remove UTM
  const handleRemoveUTM = (index: number) => {
    setUtmList(utmList.filter((_, i) => i !== index));
  };
  const handleAddHost = () => {
    const trimmedValue = hostValue.trim();
    if (trimmedValue !== "" && !hostList.includes(trimmedValue)) {
      setHostList([...hostList, trimmedValue]);
    }
    setHostValue("");
  };

  // Remove Host IP/Domain
  const handleRemoveHost = (index: number) => {
    setHostList(hostList.filter((_, i) => i !== index));
  };

  const handleAddVariable = () => {
    setVariables([
      ...variables,
      { id: Date.now(), name: "", equals: true ,value: []},
    ]);
  };
  const handleAddCookie = () => {
    setCookies([
      ...cookies,
      { id: Date.now(), name: "", value: [], equals: true },
    ]);
  };

  const handleDeleteVariable = (id: number) => {
    setVariables(variables.filter((variable) => variable.id !== id));
  };

  const handleDeleteCookie = (id: number) => {
    setCookies(cookies.filter((variable) => variable.id !== id));
  };

  const handleVariableChange = (id: number, field: string, newValue: any) => {
    const updated = variables.map((variable) =>
      variable.id === id ? { ...variable, [field]: newValue } : variable
    );
    setVariables(updated);
  };
  const handleCookieChange = (id: number, field: string, newValue: any) => {
    const updated = cookies.map((cookie) =>
      cookie.id === id ? { ...cookie, [field]: newValue } : cookie
    );
    setCookies(updated);
  };
  
  const isFormDisabled = () => {
    return tabValue !== "custom_segment";
  };
  const handleSave = async () => {
    if (!title.trim()) {
      setTitleError(true);
      return;
    }
    try {
      setIsLoading(true);
      const targetDevices = Object.entries(selectedDevices)
        .filter(([_, isChecked]) => isChecked)
        .map(([deviceName]) => deviceName);
      const targetOS = Array.from(
        new Set(
          Object.entries(selectedOS)
            .filter(([_, isChecked]) => isChecked)
            .map(([osName]) => osName.toLowerCase())
        )
      );
      const target_browsers = Array.from(
        new Set(
          Object.entries(selectedBrowsers)
            .filter(([_, isChecked]) => isChecked)
            .map(([browserName]) =>
              browserName.toLowerCase() === "other browser"
                ? "other_browser"
                : browserName.toLowerCase()
            )
        )
      );
      const selectedUserTypes = userTypeList
        .filter(({ key }) => userTypes[key])
        .map(({ key }) => key);

      let user_type: string[] = [];
      if (selectedUserTypes.length > 0) {
        user_type = selectedUserTypes;
      }

      const audienceType = tabValue;
      const segementUsers = title;
      let payload: any = {
        audience_type: audienceType,
        segment_name: segementUsers,
      };
      switch (audienceType) {
        case "all_users":
          break;

        case "custom_segment":
          payload = {
            ...payload,
            user_type,
            on_first_visit: onFirstVisit,
            target_devices: targetDevices.length ? targetDevices : undefined,
            target_os: targetOS.length ? targetOS : undefined,
            target_browsers: target_browsers.length
              ? target_browsers
              : undefined,
            adblockers: addBlockerChecked ? selectedAdblocker : undefined,
            geographic_locations: selectedLocationsList.length
              ? selectedLocationsList.map((loc) => ({
                  region: loc.region || loc.code,
                  name: loc.name,
                  toggle: geoToggle ? geoToggle.toLowerCase() : 'ignore',
                }))
              : undefined,
            postal_code_locations: postalCodesList.length
              ? postalCodesList.map((code) => ({
                  postal_code: code,
                  toggle: postalToggle ? postalToggle.toLowerCase() : 'ignore'
                }))
              : undefined,
            referred_from: referredSources.length
              ? {
                  urls: referredSources,
                  toggle: refferedToggle.toLowerCase(),
                }
              : undefined,
            utm:
              utmList.length > 0
                ? {
                    values: utmList.reduce(
                      (acc: Record<string, string[]>, utmKey: string) => {
                        const category = utmCategories[utmKey]?.toLowerCase();
                        if (category) {
                          if (!acc[category]) {
                            acc[category] = [];
                          }
                          acc[category].push(utmKey);
                        }
                        return acc;
                      },
                      {}
                    ),
                    toggle: utmToggle?.toLowerCase(),
                  }
                : undefined,

            host_ip_domains: hostList.length
              ? {
                  values: hostList,
                  toggle: hostToggle.toLowerCase(),
                }
              : undefined,
            custom_variables: variables.length
              ? variables.map((variable) => ({
                  name: variable.name,
                  value: variable.value,
                  condition: variable.equals
                    ? "equals_one_of"
                    : "does_not_equal",
                }))
              : undefined,
            custom_cookies: cookies.length
              ? cookies.map((cookie) => ({
                  name: cookie.name,
                  value: cookie.value,
                  condition: cookie.equals ? "equals_one_of" : "does_not_equal",
                }))
              : undefined,
          };
          break;

        case "everybody_else":
          payload = {
            ...payload,
            on_first_visit: onFirstVisit,
            target_devices: targetDevices.length ? targetDevices : undefined,
            target_os: targetOS.length ? targetOS : undefined,
            target_browsers: target_browsers.length
              ? target_browsers
              : undefined,
            adblockers: addBlockerChecked
              ? "adblockers_enabled"
              : "no_adblockers",
            geographic_locations: selectedLocationsList.length
              ? selectedLocationsList.map((loc) => ({
                  region: loc.code,
                  name: loc.name,
                  toggle: geoToggle.toLowerCase(),
                }))
              : undefined,
            postal_code_locations: postalCodesList.length
              ? postalCodesList.map((code) => ({
                  postal_code: code,
                  toggle: postalToggle.toLowerCase(),
                }))
              : undefined,
            referred_from: referredSources.length
              ? {
                  urls: referredSources,
                  toggle: refferedToggle.toLowerCase(),
                }
              : undefined,
            utm: utmList.length
              ? {
                  values: utmList.reduce(
                    (acc: Record<string, string>, utm: any) => {
                      acc[utm.key] = utm.value; // Ensure each entry has a key-value format
                      return acc;
                    },
                    {}
                  ),
                  toggle: utmToggle.toLowerCase(),
                }
              : undefined,

            host_ip_domains: hostList.length
              ? {
                  values: hostList,
                  toggle: hostToggle.toLowerCase(),
                }
              : undefined,
            custom_variables: variables.length
              ? variables.map((variable) => ({
                  name: variable.name,
                  value: variable.value,
                  condition: variable.equals
                    ? "equals_one_of"
                    : "does_not_equal",
                }))
              : undefined,
            custom_cookies: cookies.length
              ? cookies.map((cookie) => ({
                  name: cookie.name,
                  value: cookie.value,
                  condition: cookie.equals ? "equals_one_of" : "does_not_equal",
                }))
              : undefined,
          };
          break;

        default:
          payload = {
            ...payload,
            default_behavior: "unknown_audience_type",
          };
          break;
      }

      Object.keys(payload).forEach(
        (key) => payload[key] === undefined && delete payload[key]
      );
      let response;
      if (segmentId && segmentId !== "default") {
        response = await EditUserSegement(experienceId, segmentId, payload);
      } else {
        response = await CreateUserSegement(experienceId, payload);
      }
      if (response.success === true) {
        toast.success(response.message);
        navigate(-1);
      } else {
        toast.error(response.error);
      }
    } catch (error) {
      console.error("Error saving user segment:", error);
    } finally {
      setIsLoading(false);
    }
  };
  const onback = () => {
    navigate(`/edit-experience/${experienceId}`);
  };
  return (
    <>
      <div className="templates ">
        <Grid container className="templates__header">
          <Grid
            size={{ xs: 12, md: 3, sm: 6 }}
            className="templates__header--search"
          >
            <div className="d-center">
              <span className="Icon">
                <IconButton aria-label="close" onClick={onback}>
                  <ArrowbackIcon />
                </IconButton>{" "}
              </span>{" "}
              <h2 className="mb-0"> User segment </h2>
            </div>{" "}
          </Grid>

          <Grid
            size={{ xs: 12, md: 9, sm: 6 }}
            className="templates__header--button "
          >
            <Box className="button-heading">
              <Button
                variant="contained"
                className="button"
                sx={{
                  "--variant-containedBg": "rgba(228, 0, 43, 1)",
                  "&:hover": {
                    "--variant-containedBg": "rgba(228, 0, 43, 1)",
                    "--variant-textBg": "rgba(228, 0, 43, 0.04)",
                  },
                }}
                color="error"
                type="submit"
                onClick={handleSave}
                disabled={loading}
              >
                {loading ? <span className="loader" /> : "Save"}
              </Button>
              <Button
                className="button"
                variant="outlined"
                onClick={onback}
                sx={{
                  "--variant-outlinedBorder": "rgba(228, 0, 43, 1)",
                  "--variant-outlinedColor": "rgba(228, 0, 43, 1)",
                  "--variant-containedBg": "rgba(228, 0, 43, 1)",

                  "&:hover": {
                    "--variant-outlinedBorder": "rgba(228, 0, 43, 1)",
                    "--variant-outlinedBg": "rgba(228, 0, 43, 0.04)",
                    "--variant-containedBg": "rgba(228, 0, 43, 1)",
                    "--variant-textBg": "rgba(228, 0, 43, 0.04)",
                  },
                }}
              >
                Cancel
              </Button>
            </Box>
          </Grid>
        </Grid>

        <Box className="editSegment__container" mt={2}>
          <Grid
            container
            spacing={{ xs: 0, sm: 2, md: 2 }}
            alignItems={"center"}
          >
            <Grid size={{ xs: 12, md: 2, sm: 3 }}>
              <div className="editSegment__container--heading">
                <h2>TITLE OF CARD :</h2>
              </div>
            </Grid>
            <Grid
              size={{ xs: 12, md: 8, sm: 9 }}
              className="editSegment__container--heading"
            >
              <TextField
                variant="standard"
                value={title}
                onChange={(e) => {
                  setTitle(e.target.value);
                  if (e.target.value.trim()) {
                    setTitleError(false); // clear error as user types
                  }
                }}
                fullWidth
                required
                error={titleError}
                helperText={titleError ? "Title is required" : ""}
              />
            </Grid>
          </Grid>
        </Box>
        <Box className="editSegment__container">
          <Grid
            container
            spacing={{ xs: 0, sm: 0, md: 2 }}
            alignItems={"center"}
          >
            <Grid size={{ xs: 12, md: 3, sm: 12 }}>
              <div className="editSegment__container--heading br-1">
                <h3> Define your audience</h3>
              </div>
            </Grid>
            <Grid size={{ xs: 12, md: 9, sm: 12 }}>
              <div className="editSegment__container--tab">
                <Tabs
                  value={tabValue}
                  onChange={handleChange}
                  indicatorColor="primary"
                  variant="scrollable"
                >
                  <Tab
                    label="All Users"
                    value="all_users"
                    sx={{
                      fontWeight: "bold",
                      color:
                        tabValue === "all_users"
                          ? "rgb(228, 0, 43)"
                          : "inherit",
                    }}
                  />

                  <Tab
                    label="Custom segment"
                    value="custom_segment"
                    sx={{
                      fontWeight: "bold",
                      color:
                        tabValue === "custom_segment"
                          ? "rgb(228, 0, 43)"
                          : "inherit",
                    }}
                  />
                  <Tab
                    label="Everybody else"
                    value="everybody_else"
                    sx={{
                      fontWeight: "bold",
                      color:
                        tabValue === "everybody_else"
                          ? "rgb(228, 0, 43)"
                          : "inherit",
                    }}
                  />
                </Tabs>
              </div>
            </Grid>
          </Grid>
        </Box>
        <Box className="editSegment__container">
          <div>
            <Accordion defaultExpanded disabled={isFormDisabled()}>
              <AccordionSummary expandIcon={<ExpandMoreIcon />}>
                <h3> Browsing properties</h3>
              </AccordionSummary>

              <Box className="editSegment__container" ml={2} mr={2} mb={2}>
                <div className="editSegment__container--innerheading bb-1 ">
                  <Grid container spacing={2} alignItems={"center"}>
                    <Grid size={{ xs: 6, md: 3 }}>
                      <div className=" ">
                        <h2> User Type</h2>
                      </div>
                    </Grid>
                    <Grid container spacing={2}>
                      {userTypeList.map(({ key, label }) => (
                        <Grid>
                          <FormControlLabel
                            className="check_box"
                            value="end"
                            control={
                              <Checkbox
                                checked={userTypes[key]}
                                onChange={(e) =>
                                  setUserTypes({
                                    ...userTypes,
                                    [key]: e.target.checked,
                                  })
                                }
                                disabled={isFormDisabled()}
                              />
                            }
                            label={label}
                            labelPlacement="end"
                          />
                        </Grid>
                      ))}
                    </Grid>
                  </Grid>
                </div>

                <div className="editSegment__container--innerheading bb-1">
                  <Grid container spacing={2} alignItems={"center"}>
                    <Grid size={{ xs: 6, md: 12 }}>
                      <FormControlLabel
                        className="check_box"
                        value="end"
                        control={
                          <Checkbox
                            checked={onFirstVisit}
                            onChange={() => setOnFirstVisit(!onFirstVisit)}
                            disabled={isFormDisabled()}
                          />
                        }
                        label="On first visit "
                        labelPlacement="end"
                      />
                    </Grid>
                  </Grid>
                </div>

                <div className="editSegment__container--innerheading bb-1">
                  <Grid container spacing={2} alignItems={"center"}>
                    <Grid size={{ xs: 6, md: 3 }}>
                      <FormControlLabel
                        className="check_box"
                        value="end"
                        control={
                          <Checkbox
                            checked={deviceChecked}
                            onChange={handleDeviceChange}
                            disabled={isFormDisabled()}
                          />
                        }
                        label="Device"
                        labelPlacement="end"
                      />
                    </Grid>

                    {DeviceList.map((de) => (
                      <Grid
                        size={{ xs: 6, md: 2 }}
                        key={de}
                        className="checkbox-wrapper-29"
                      >
                        <FormControlLabel
                          className="check_box"
                          value="end"
                          control={
                            <Checkbox
                              checked={selectedDevices[de] || false}
                              onChange={(e) => {
                                setSelectedDevices({
                                  ...selectedDevices,
                                  [de]: e.target.checked,
                                });
                              }}
                              disabled={!deviceChecked || isFormDisabled()}
                            />
                          }
                          label={de.charAt(0).toUpperCase() + de.slice(1)}
                          labelPlacement="end"
                        />
                      </Grid>
                    ))}
                  </Grid>
                </div>

                <div className="editSegment__container--innerheading bb-1">
                  <Grid container spacing={2} alignItems={"center"}>
                    <Grid size={{ xs: 6, md: 3 }}>
                      <FormControlLabel
                        className="check_box"
                        value="end"
                        control={
                          <Checkbox
                            checked={osChecked}
                            onChange={handleOsChange}
                            disabled={isFormDisabled()}
                          />
                        }
                        label=" Operating system"
                        labelPlacement="end"
                      />
                    </Grid>

                    {Object.keys(osToDeviceMap).map((os) => (
                      <Grid key={os}>
                        <FormControlLabel
                          className="check_box"
                          value="end"
                          control={
                            <Checkbox
                              checked={selectedOS[os] || false}
                              onChange={(e) => {
                                setSelectedOS({
                                  ...selectedOS,
                                  [os]: e.target.checked,
                                });
                              }}
                              disabled={!osChecked || isFormDisabled()}
                            />
                          }
                          label={osToDeviceMap[os]}
                          labelPlacement="end"
                        />
                      </Grid>
                    ))}
                  </Grid>
                </div>

                <div className="editSegment__container--innerheading bb-1">
                  <Grid container spacing={2} alignItems={"center"}>
                    <Grid size={{ xs: 6, md: 3 }}>
                      <FormControlLabel
                        className="check_box"
                        value="end"
                        control={
                          <Checkbox
                            checked={browserChecked}
                            onChange={handleBrowserChange}
                            disabled={isFormDisabled()}
                          />
                        }
                        label="Browser Section"
                        labelPlacement="end"
                      />
                    </Grid>

                    {Object.keys(browserDisplayLabels).map((br) => (
                      <Grid key={br}>
                        <FormControlLabel
                          className="check_box"
                          value="end"
                          control={
                            <Checkbox
                              checked={selectedBrowsers[br] || false}
                              onChange={(e) => {
                                setSelectedBrowsers({
                                  ...selectedBrowsers,
                                  [br]: e.target.checked,
                                });
                              }}
                              disabled={!browserChecked || isFormDisabled()}
                            />
                          }
                          label={browserDisplayLabels[br]}
                          labelPlacement="end"
                        />
                      </Grid>
                    ))}
                  </Grid>
                </div>

                <div className="editSegment__container--innerheading bb-1">
                  <Grid container spacing={2} alignItems={"center"}>
                    <Grid size={{ xs: 6, md: 3 }}>
                      <FormControlLabel
                        className="check_box"
                        value="end"
                        control={
                          <Checkbox
                            checked={addBlockerChecked}
                            onChange={handleAddBlockerChange}
                            disabled={isFormDisabled()}
                          />
                        }
                        label="Adblockers"
                        labelPlacement="end"
                      />
                    </Grid>

                    {AdblockersList.map((ad) => (
                      <Grid key={ad.value}>
                        <FormControlLabel
                          className="check_box"
                          value={ad.value}
                          control={
                            <Checkbox
                              checked={selectedAdblocker === ad.value}
                              onChange={(e: any) => {
                                if (e.target.checked) {
                                  setSelectedAdblocker(ad.value);
                                } else {
                                  setSelectedAdblocker("");
                                }
                              }}
                              disabled={!addBlockerChecked || isFormDisabled()}
                            />
                          }
                          label={ad.label}
                          labelPlacement="end"
                        />
                      </Grid>
                    ))}
                  </Grid>
                </div>

                <div className="editSegment__container--innerheading bb-1">
                  <Grid container spacing={1}>
                    <Grid
                      className="editSegment__container--box"
                      size={{ xs: 12, md: 4, sm: 6 }}
                    >
                      <div className="editSegment__container--box--block">
                        {/* Geographic Location Checkbox */}
                        <Box className="editSegment__container--box--header">
                          {/* Geographic Location Checkbox */}

                          {/* Switch (Aligned to the right) */}
                          <Typography variant="subtitle1" p={2}>
                            <span>
                              <FormControlLabel
                                className="check_box"
                                value="end"
                                control={
                                  <Checkbox
                                    checked={geoChecked}
                                    onChange={(e) =>
                                      setGeoChecked(e.target.checked)
                                    }
                                    disabled={isFormDisabled()}
                                  />
                                }
                                label=" Geographic Location"
                                labelPlacement="end"
                              />
                            </span>{" "}
                          </Typography>

                          <div className="switch-wrapper user-segment-toggle">
                            <p className="ignore">IGNORE</p>
                            <label className="switch">
                              <input
                                type="checkbox"
                                disabled={!geoChecked || isFormDisabled()}
                                checked={geoToggle === "TARGET"}
                                onChange={() =>
                                  setGeoToggle(
                                    geoToggle === "IGNORE" ? "TARGET" : "IGNORE"
                                  )
                                }
                              />
                              <span className="slider"></span>
                            </label>

                            <p className="target">TARGET</p>
                          </div>
                        </Box>
                        <Box className="cardEditpage__content--box ">
                          {selectedLocationsList.length > 0 && (
                            <>
                              {selectedLocationsList.map((loc) => (
                                <Box
                                  key={loc.code}
                                  display="flex"
                                  alignItems="center"
                                  justifyContent="space-between"
                                  gap={1}
                                  mb={1}
                                >
                                  <p className="loc">{loc.name}</p>

                                  <IconButton
                                    className="Icon"
                                    color="error"
                                    onClick={() =>
                                      handleRemoveLocation(loc.code)
                                    }
                                    disabled={isFormDisabled()}
                                  >
                                    <CrossIcon fontSize="medium" />
                                  </IconButton>
                                </Box>
                              ))}
                            </>
                          )}
                        </Box>
                        <Autocomplete
                          disablePortal
                          options={newLocation}
                          getOptionLabel={(option: any) => option?.name || ""}
                          value={selectedLocation}
                          onChange={(event: any, newValue: any) =>
                            setSelectedLocation(newValue)
                          }
                          disabled={!geoChecked || isFormDisabled()}
                          renderInput={(params: any) => (
                            <TextField
                              variant="standard"
                              {...params}
                              size="small"
                              fullWidth
                            />
                          )}
                          sx={{
                            borderTop: "1px solid rgba(212, 212, 212, 1)",
                            padding: "10px 12px",
                          }}
                          onKeyDown={(e) =>
                            e.key === "Enter" && handleAddLocation()
                          }
                        />
                      </div>
                    </Grid>

                    <Grid
                      className="editSegment__container--box"
                      size={{ xs: 12, md: 4, sm: 6 }}
                    >
                      <div className="editSegment__container--box--block">
                        <Box className="editSegment__container--box--header">
                          <Typography variant="subtitle1" p={2}>
                            <span>
                              <FormControlLabel
                                className="check_box"
                                value="end"
                                control={
                                  <Checkbox
                                    checked={postalChecked}
                                    onChange={(e) =>
                                      setpostalChecked(e.target.checked)
                                    }
                                    disabled={isFormDisabled()}
                                  />
                                }
                                label="Postal code location"
                                labelPlacement="end"
                              />
                            </span>{" "}
                          </Typography>

                          <div className="switch-wrapper user-segment-toggle">
                            <p className="ignore">IGNORE</p>
                            <label className="switch">
                              <input
                                type="checkbox"
                                disabled={!postalChecked || isFormDisabled()}
                                checked={postalToggle === "TARGET"}
                                onChange={() =>
                                  setPostalToggle(
                                    postalToggle === "IGNORE"
                                      ? "TARGET"
                                      : "IGNORE"
                                  )
                                }
                              />
                              <span className="slider"></span>
                            </label>

                            <p className="target">TARGET</p>
                          </div>
                        </Box>
                        <Box className="cardEditpage__content--box ">
                          {postalCodesList.length > 0 && (
                            <>
                              {postalCodesList.map((code, index) => (
                                <Box
                                  key={index}
                                  display="flex"
                                  alignItems="center"
                                  justifyContent="space-between"
                                  gap={1}
                                  mb={1}
                                >
                                  <p className="loc">{code}</p>

                                  <IconButton
                                    className="Icon"
                                    color="error"
                                    onClick={() => handleRemovePostal(index)}
                                    disabled={isFormDisabled()}
                                  >
                                    <CrossIcon fontSize="medium" />
                                  </IconButton>
                                </Box>
                              ))}
                            </>
                          )}
                        </Box>
                        <TextField
                          size="small"
                          variant="standard"
                          placeholder="Enter postal code"
                          fullWidth
                          disabled={!postalChecked || isFormDisabled()}
                          value={postalCode}
                          onChange={(e) => setPostalCode(e.target.value)}
                          onKeyDown={(e) =>
                            e.key === "Enter" && handleAddPostalCode()
                          }
                          sx={{
                            borderTop: "1px solid rgba(212, 212, 212, 1)",
                            padding: "10px 12px",
                          }}
                        />
                      </div>
                    </Grid>

                    <Grid
                      className="editSegment__container--box"
                      size={{ xs: 12, md: 4, sm: 6 }}
                    >
                      <div className="editSegment__container--box--block">
                        {/* Geographic Location Checkbox */}
                        <Box className="editSegment__container--box--header">
                          {/* Geographic Location Checkbox */}

                          {/* Switch (Aligned to the right) */}
                          <Typography variant="subtitle1" p={2}>
                            <span>
                              <FormControlLabel
                                className="check_box"
                                value="end"
                                control={
                                  <Checkbox
                                    checked={referredChecked}
                                    onChange={(e) =>
                                      setReferredChecked(e.target.checked)
                                    }
                                    disabled={isFormDisabled()}
                                  />
                                }
                                label="Referred From"
                                labelPlacement="end"
                              />
                            </span>{" "}
                          </Typography>

                          <div className="switch-wrapper user-segment-toggle">
                            <p className="ignore">IGNORE</p>
                            <label className="switch">
                              <input
                                type="checkbox"
                                disabled={!referredChecked || isFormDisabled()}
                                checked={refferedToggle === "TARGET"}
                                onChange={() =>
                                  setRefferedToggle(
                                    refferedToggle === "IGNORE"
                                      ? "TARGET"
                                      : "IGNORE"
                                  )
                                }
                              />
                              <span className="slider"></span>
                            </label>

                            <p className="target">TARGET</p>
                          </div>
                        </Box>
                        <Box className="cardEditpage__content--box ">
                          {referredSources.map((ref, index) => (
                            <Box
                              key={index}
                              display="flex"
                              alignItems="center"
                              justifyContent="space-between"
                              gap={1}
                              mb={1}
                            >
                              <div>
                                <FormControlLabel
                                  className="check_box"
                                  value="end"
                                  control={
                                    <Checkbox
                                      className="checkbox__input"
                                      disabled={
                                        !referredChecked || isFormDisabled()
                                      }
                                    />
                                  }
                                  label={ref}
                                  labelPlacement="end"
                                />
                              </div>

                              <IconButton
                                className="Icon"
                                color="error"
                                onClick={() => handleRemoveLink(index)}
                                disabled={!referredChecked || isFormDisabled()}
                              >
                                <CrossIcon fontSize="medium" />
                              </IconButton>
                            </Box>
                          ))}
                        </Box>
                        <TextField
                          size="small"
                          variant="standard"
                          placeholder="Enter Link Address"
                          fullWidth
                          disabled={!referredChecked || isFormDisabled()}
                          value={linkAddress}
                          onChange={(e) => setLinkAddress(e.target.value)}
                          onKeyDown={(e) =>
                            e.key === "Enter" && handleAddLink()
                          }
                          sx={{
                            borderTop: "1px solid rgba(212, 212, 212, 1)",
                            padding: "10px 12px",
                          }}
                        />
                      </div>
                    </Grid>

                    <Grid
                      className="editSegment__container--box"
                      size={{ xs: 12, md: 4, sm: 6 }}
                    >
                      <div className="editSegment__container--box--block">
                        {/* Geographic Location Checkbox */}
                        <Box className="editSegment__container--box--header">
                          {/* Geographic Location Checkbox */}

                          {/* Switch (Aligned to the right) */}
                          <Typography variant="subtitle1" p={2}>
                            <span>
                              <FormControlLabel
                                className="check_box everyday"
                                value="end"
                                control={
                                  <Checkbox
                                    checked={utmChecked}
                                    onChange={(e) =>
                                      setUtmChecked(e.target.checked)
                                    }
                                    disabled={isFormDisabled()}
                                  />
                                }
                                label="UTM"
                                labelPlacement="end"
                              />
                            </span>{" "}
                          </Typography>

                          <div className="switch-wrapper user-segment-toggle">
                            <p className="ignore">IGNORE</p>
                            <label className="switch">
                              <input
                                type="checkbox"
                                disabled={!utmChecked || isFormDisabled()}
                                checked={utmToggle === "TARGET"}
                                onChange={() =>
                                  setUtmToggle(
                                    utmToggle === "IGNORE" ? "TARGET" : "IGNORE"
                                  )
                                }
                              />
                              <span className="slider"></span>
                            </label>

                            <p className="target">TARGET</p>
                          </div>
                        </Box>
                        <Box className="cardEditpage__content--box">
                          {utmList.length > 0 && (
                            <>
                              {utmList.map((utm, index) => (
                                <Box
                                  key={index}
                                  display="flex"
                                  alignItems="center"
                                  gap={2}
                                  mb={1}
                                >
                                  {/* UTM value as read-only input */}
                                  <Autocomplete
                                    options={UTMOptions}
                                    value={utmCategories[utm]}
                                    onChange={(event, newValue) =>
                                      handleCategoryChange(utm, newValue)
                                    }
                                    disableClearable
                                    size="small"
                                    sx={{ width: "40%" }}
                                    renderInput={(params) => (
                                      <TextField
                                        {...params}
                                        variant="outlined"
                                      />
                                    )}
                                  />
                                  <TextField
                                    value={utm}
                                    variant="outlined"
                                    size="small"
                                    disabled
                                    sx={{ width: "50%" }}
                                  />

                                  {/* Category Dropdown */}
                                  

                                  {/* Delete Button */}
                                  <IconButton
                                    color="error"
                                    onClick={() => handleRemoveUTM(index)}
                                    disabled={!utmChecked || isFormDisabled()}
                                  >
                                    <CrossIcon fontSize="medium" />
                                  </IconButton>
                                </Box>
                              ))}
                            </>
                          )}
                        </Box>
                        <TextField
                          size="small"
                          variant="standard"
                          placeholder="Enter UTM"
                          fullWidth
                          disabled={!utmChecked || isFormDisabled()}
                          sx={{
                            borderTop: "1px solid rgba(212, 212, 212, 1)",
                            padding: "10px 12px",
                          }}
                          value={utmValue}
                          onChange={(e) => setUtmValue(e.target.value)}
                          onKeyDown={(e) => e.key === "Enter" && handleAddUTM()}
                        />
                      </div>
                    </Grid>

                    <Grid
                      className="editSegment__container--box"
                      size={{ xs: 12, md: 4, sm: 6 }}
                    >
                      <div className="editSegment__container--box--block">
                        <Box className="editSegment__container--box--header">
                          <Typography variant="subtitle1" p={2}>
                            <span>
                              <FormControlLabel
                                className="check_box"
                                value="end"
                                control={
                                  <Checkbox
                                    className="checkbox__input"
                                    checked={hostChecked}
                                    onChange={(e) =>
                                      setHostChecked(e.target.checked)
                                    }
                                    disabled={isFormDisabled()}
                                  />
                                }
                                label=" Host IP/Domain"
                                labelPlacement="end"
                              />
                            </span>{" "}
                          </Typography>

                          <div className="switch-wrapper user-segment-toggle">
                            <p className="ignore">IGNORE</p>
                            <label className="switch">
                              <input
                                type="checkbox"
                                disabled={!hostChecked || isFormDisabled()}
                                checked={hostToggle === "TARGET"}
                                onChange={() =>
                                  setHostToggle(
                                    hostToggle === "IGNORE"
                                      ? "TARGET"
                                      : "IGNORE"
                                  )
                                }
                              />
                              <span className="slider"></span>
                            </label>

                            <p className="target">TARGET</p>
                          </div>
                        </Box>
                        <Box className="cardEditpage__content--box ">
                          {hostList.map((host, index) => (
                            <Box
                              key={index}
                              display="flex"
                              alignItems="center"
                              justifyContent="space-between"
                              gap={1}
                              mb={1}
                            >
                              <div>
                                <FormControlLabel
                                  className="check_box everyday"
                                  value="end"
                                  control={
                                    <Checkbox
                                      defaultChecked
                                      className="checkbox__input"
                                      disabled={
                                        !hostChecked || isFormDisabled()
                                      }
                                    />
                                  }
                                  label={host}
                                  labelPlacement="end"
                                />
                              </div>

                              <IconButton
                                className="Icon"
                                color="error"
                                onClick={() => handleRemoveHost(index)}
                                disabled={!hostChecked || isFormDisabled()}
                              >
                                <CrossIcon fontSize="medium" />
                              </IconButton>
                            </Box>
                          ))}
                        </Box>
                        <TextField
                          size="small"
                          variant="standard"
                          placeholder="Enter host IP/domain"
                          fullWidth
                          disabled={!hostChecked || isFormDisabled()}
                          sx={{
                            borderTop: "1px solid rgba(212, 212, 212, 1)",
                            padding: "10px 12px",
                          }}
                          value={hostValue}
                          onChange={(e) => setHostValue(e.target.value)}
                          onKeyDown={(e) =>
                            e.key === "Enter" && handleAddHost()
                          }
                        />
                      </div>
                    </Grid>
                  </Grid>
                </div>
              </Box>
            </Accordion>
          </div>
        </Box>

        <Box className="editSegment__container">
          <div>
            <Accordion defaultExpanded disabled={isFormDisabled()} sx={{}}>
              <AccordionSummary expandIcon={<ExpandMoreIcon />}>
                <h3> Custom Variables</h3>
              </AccordionSummary>
              <AccordionDetails>
                {variables.map((variable: any) => (
                  <Box
                    key={variable.id}
                    display="flex"
                    alignItems="center"
                    flexWrap={'wrap'}
                    gap={1}
                    sx={{ mb: 2, width: "100%" }}
                  >
                    {/* Variable Name */}
                    <TextField
                      sx={{ flex: 1 }}
                      label="Variable Name"
                      variant="outlined"
                      value={variable.name}
                      onChange={(e) =>
                        handleVariableChange(
                          variable.id,
                          "name",
                          e.target.value
                        )
                      }
                      disabled={isFormDisabled()}
                    />

                    {/* Switch & Labels */}
                    <Typography variant="body2">Does Not Equal</Typography>
                    <div className="switch-wrapper user-segment-toggle">
                      <label className="switch">
                        <input
                          type="checkbox"
                          checked={variable.equals}
                          disabled={isFormDisabled()}
                          onChange={(e) =>
                            handleVariableChange(
                              variable.id,
                              "equals",
                              e.target.checked
                            )
                          }
                        />
                        <span className="slider"></span>
                      </label>
                    </div>

                    <Typography variant="body2">Equals One Of</Typography>

                    {/* Variable Value */}
                    <Autocomplete
                      multiple
                      freeSolo
                      options={[]} // no preset options
                      value={variable.value}
                      onChange={(event, newValue) =>
                        handleVariableChange(variable.id, "value", newValue)
                      }
                      disabled={isFormDisabled()}
                      sx={{ width: 400 }}
                      renderTags={(value: readonly string[], getTagProps) =>
                        value.map((option: string, index: number) => (
                          <React.Fragment key={index}>
                            <Chip
                              variant="outlined"
                              label={option}
                              {...getTagProps({ index })}
                            />
                            {index < value.length - 1 && (
                              <Typography
                                variant="body2"
                                sx={{
                                  mx: 1,
                                  display: "inline-block",
                                  color: "gray",
                                }}
                              >
                                {variable.equals ? "OR" : "AND"}
                              </Typography>
                            )}
                          </React.Fragment>
                        ))
                      }
                      renderInput={(params) => (
                        <TextField
                          {...params}
                          variant="outlined"
                          label="Variable Values"
                          placeholder="Enter and press Enter"
                        />
                      )}
                    />

                    {/* Delete Button */}
                    <IconButton
                      className="Icon"
                      color="error"
                      onClick={() => handleDeleteVariable(variable.id)}
                      disabled={isFormDisabled()}
                    >
                      <CrossIcon fontSize="medium" />
                    </IconButton>
                  </Box>
                ))}
                {/* Add Button */}
                <button
                  className="button-submit"
                  onClick={handleAddVariable}
                  disabled={isFormDisabled()}
                >
                  <span className="Icon">
                    <AddIcon />
                  </span>
                  Add Custom Variables
                </button>
              </AccordionDetails>
            </Accordion>
            <Accordion defaultExpanded disabled={isFormDisabled()} sx={{}}>
              <AccordionSummary expandIcon={<ExpandMoreIcon />}>
                <h3> Custom Cookies</h3>
              </AccordionSummary>
              <AccordionDetails>
                {cookies.map((cookie: any) => (
                  <Box
                    key={cookie.id}
                    display="flex"
                    alignItems="center"
                    gap={1}
                    sx={{ mb: 2, width: "100%" }}
                  >
                    {/* Variable Name */}
                    <TextField
                      sx={{ flex: 1 }}
                      label="Cookie Name"
                      variant="outlined"
                      value={cookie.name}
                      onChange={(e) =>
                        handleCookieChange(cookie.id, "name", e.target.value)
                      }
                      disabled={isFormDisabled()}
                    />

                    {/* Switch & Labels */}
                    <Typography variant="body2">Does Not Equal</Typography>
                    <div className="switch-wrapper user-segment-toggle">
                      <label className="switch">
                        <input
                          type="checkbox"
                          checked={cookie.equals}
                          disabled={isFormDisabled()}
                          onChange={(e) =>
                            handleCookieChange(
                              cookie.id,
                              "equals",
                              e.target.checked
                            )
                          }
                        />
                        <span className="slider"></span>
                      </label>
                    </div>

                    <Typography variant="body2">Equals One Of</Typography>

                    {/* Variable Value */}
                    <Autocomplete
                      multiple
                      freeSolo
                      options={[]} // no preset options
                      value={cookie.value}
                      onChange={(event, newValue) =>
                        handleCookieChange(cookie.id, "value", newValue)
                      }
                      disabled={isFormDisabled()}
                      sx={{ width: 400 }}
                      renderTags={(value: readonly string[], getTagProps) =>
                        value.map((option: string, index: number) => (
                          <React.Fragment key={index}>
                            <Chip
                              variant="outlined"
                              label={option}
                              {...getTagProps({ index })}
                            />
                            {index < value.length - 1 && (
                              <Typography
                                variant="body2"
                                sx={{
                                  mx: 1,
                                  display: "inline-block",
                                  color: "gray",
                                }}
                              >
                                {cookie.equals ? "OR" : "AND"}
                              </Typography>
                            )}
                          </React.Fragment>
                        ))
                      }
                      renderInput={(params) => (
                        <TextField
                          {...params}
                          variant="outlined"
                          label="Cookie Values"
                          placeholder="Enter and press Enter"
                        />
                      )}
                    />

                    {/* Delete Button */}
                    <IconButton
                      className="Icon"
                      color="error"
                      onClick={() => handleDeleteCookie(cookie.id)}
                      disabled={isFormDisabled()}
                    >
                      <CrossIcon fontSize="medium" />
                    </IconButton>
                  </Box>
                ))}
                {/* Add Button */}
                <button
                  className="button-submit"
                  onClick={handleAddCookie}
                  disabled={isFormDisabled()}
                >
                  <span className="Icon">
                    <AddIcon />
                  </span>
                  Add Custom Cookies
                </button>
              </AccordionDetails>
            </Accordion>
            <ToastContainer position="top-right" autoClose={3000} />
          </div>
        </Box>
      </div>
    </>
  );
};

export default EditUserSegment;
